<ol class="inspections">
  <li>
    <span class="inspection-item">תוצאות הבדיקה:</span>
    <ol>
      <li>
        <span class="case">כללי:</span>
        <ol class="notes">
          <li *ngFor="let item of mainItems">
            <strong>{{ item.label }}: {{ item.value }}</strong>
            <ol class="notes">
              <li *ngFor="let note of item.notes">
                <strong>{{ note.notes }}</strong>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <span class="case">להלן רשימת האזורים שנבדקו:</span>
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 10%">
                <strong>מערכת מס'</strong>
              </th>
              <th style="width: 20%">
                <strong>כיבוי הותקן ב-</strong>
              </th>
              <th style="width: 10%">
                <strong>נפח החלל המוגן מ"ק</strong>
              </th>
              <th style="width: 15%">
                <strong>מיכל מדגם</strong>
              </th>
              <th style="width: 12%">
                <strong>מיכל מתוצרת</strong>
              </th>
              <th style="width: 10%">
                <strong>משקל הגז</strong>
              </th>
              <th style="width: 10%">
                <strong>נחיר מדגם</strong>
              </th>
              <th style="width: 12%">
                <strong>סוג צנרת</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let area of inspection.gasExtinguishingSystemDesign.areas;
                index as i
              "
            >
              <td>
                <span>{{ i + 1 }}</span>
              </td>
              <td>
                <span>{{
                  area?.gasExtinguishingSystem?.boardDetailsOrProtectedSpace
                    .value
                }}</span>
              </td>
              <td>
                <span>{{
                  area?.gasExtinguishingSystem?.boardDimensions?.volume
                }}</span>
              </td>
              <td>
                <span>{{
                  area?.gasExtinguishingSystem?.containerModel.value
                }}</span>
              </td>
              <td>
                <span>{{
                  area?.gasExtinguishingSystem?.tankMadeOf.value
                }}</span>
              </td>
              <td>
                <span>{{ area?.gasExtinguishingSystem?.gasWeight.value }}</span>
              </td>
              <td>
                <span>{{
                  area?.gasExtinguishingSystem?.modelDispersionNozzledDesign
                    .value
                }}</span>
              </td>
              <td>
                <span>{{
                  area?.gasExtinguishingSystem?.pipeDesignType.value
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
    </ol>
  </li>
  <br />
  <li>
    <span class="inspection-item">הערות נוספות על ידי המעבדה:</span>
    <ol class="notes">
      <li *ngFor="let area of areasNotes">
        <strong>{{ area.title }}</strong>
        <ol class="notes">
          <li *ngFor="let note of area.notes">
            <strong>{{ note }}</strong>
          </li>
        </ol>
      </li>
    </ol>
  </li>

  <authority-labs-summary-notes
    [summaryNotes]="inspection?.summaryNotes"
  ></authority-labs-summary-notes>
</ol>
